export enum OrgImpactPanel {
  Applications = 'applications',
  Servers = 'servers'
}

interface CVE {
  id: number
  name: string
  description: string
  status: string
  cwe: string
  epssScore: number
  epssPercentile: number
  cisa: boolean
  nvdPublished: number
  nvdModified: number
  firstSeen: any
  cvssv3: CVSSv3 | null | undefined
  cvssv2: CVSSv2
}

export interface CVSSv3 {
  attackVector: string
  attackComplexity: string
  privilegesRequired: string
  userInteraction: string
  scope: string
  confidentialityImpact: string
  integrityImpact: string
  availabilityImpact: string
  baseScore: number
  vector: string
  severity: string
  impactSubscore: number
  exploitabilitySubscore: number
}

export interface CVSSv2 {
  accessVector: string
  accessComplexity: string
  authentication: string
  confidentialityImpact: string
  integrityImpact: string
  availabilityImpact: string
  exploitability: string | null
  remediationLevel: string | null
  reportConfidence: string | null
  collateralDamagePotential: string | null
  targetDistribution: string | null
  confidentialityRequirement: string | null
  integrityRequirement: string | null
  availabilityRequirement: string | null
  severity: string
}

interface ImpactStats {
  impactedAppCount: number
  totalAppCount: number
  impactedServerCount: number
  totalServerCount: number
  appPercentage: number
  serverPercentage: number
}

interface Library {
  hash: string
  version: string
  file_name: string
  group: string
}

export interface App {
  name: string
  app_id: string
  last_seen: number
  last_reset: number | null
  first_seen: number
  importance_description: string
}

export interface Server {
  server_id: number
  name: string
  hostname: string
  path: string
  type: string
  environment: string
  status: string
}

export interface VulnerabilityReport {
  cve: CVE
  impactStats: ImpactStats
  libraries: Library[]
  apps: App[]
  servers: Server[]
}
